import * as THREE from 'three';
import type { IPointerController, IPointerHandler } from '@/components/viewPort/PointerController';
import type { IViewPortManager } from '../../interfaces';
import type { IIndicationsController } from './Indications.controller';
import pencilIcon from '../../../../assets/cursors/pencilcur.svg';
import type { ICursorSetter } from './ToolsManager';
import type { PointerSyntheticEvent } from '@/components/viewPort/PointerSyntheticEvent';

const pencilCur = `url(${pencilIcon}) 1 29, auto`;

export class IndicationsPointerHandler implements IPointerHandler, ICursorSetter {
  private _vpm: IViewPortManager;

  private _indicationsController: IIndicationsController;

  private _parent?: IPointerController;

  private _lastPointerDownOffsetX: number | undefined;

  private _lastPointerDownOffsetY: number | undefined;

  public constructor(vpm: IViewPortManager, indicationsController: IIndicationsController) {
    this._vpm = vpm;
    this._indicationsController = indicationsController;
  }

  public setParent(parent: IPointerController): void {
    this._parent = parent;
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises -- //TODO: [chebotarev] fix eslint no-misused-promises
  public async onFixedClick(event: PointerSyntheticEvent): Promise<void> {
    const { offsetX, offsetY } = event.originalEvent;

    if (this._lastPointerDownOffsetX === offsetX && this._lastPointerDownOffsetY === offsetY) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    const point = this._vpm.getRaycaster().rayCast(new THREE.Vector2(offsetX, offsetY))?.point;
    if (point !== undefined) {
      await this._indicationsController.onPointAddAsync(point, event);
    }
    this._lastPointerDownOffsetX = offsetX;
    this._lastPointerDownOffsetY = offsetY;
  }

  public onPointerMove(event: PointerSyntheticEvent): void {
    event.preventDefault();
    const { offsetX, offsetY } = event.originalEvent;
    const point = this._vpm.getRaycaster().rayCast(new THREE.Vector2(offsetX, offsetY))?.point;
    if (point !== undefined) {
      this._parent?.setCursor(pencilCur);
      this._indicationsController.onPointMove(point, event);
    } else {
      this._parent?.setCursor('');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises -- //TODO: [chebotarev] fix eslint no-misused-promises
  public onDblClick(): Promise<void> {
    this._indicationsController.onFinalize();
    return Promise.resolve();
  }

  /**
   * preventDefault() in onPointerMove refers to mouse event. This is the equivalent for touch event.
   * Both prevent PointerHandlerPickObject pushing handler to the stack.
   */
  public onPointerEnter(event: PointerSyntheticEvent): void {
    event.preventDefault(); 
  }
  
  public onPointerLeave(/*event: SyntheticEvent<PointerEvent>*/): void {
    this._parent?.setCursor('');
  }

  public setCursor(cursor: string): void {
    this._parent?.setCursor(cursor);
  }
}
